// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"83cd99b1","484":"26838a4a"}[chunkId] + ".chunk.js";
};